import { PropsWithChildren, ReactElement } from 'react';

import { CssBaseline, ThemeProvider } from '@mui/material';
import { horizonTheme } from '@/lib/theme/horizon-theme';

const MuiThemeProvider = (props: PropsWithChildren): ReactElement => {
  return (
    <ThemeProvider theme={horizonTheme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
};

export default MuiThemeProvider;
